import script from "./AnimatedDivider.vue?vue&type=script&lang=ts&setup=true"
export * from "./AnimatedDivider.vue?vue&type=script&lang=ts&setup=true"

import "./AnimatedDivider.vue?vue&type=style&index=0&id=255a6ae6&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-255a6ae6"]])

export default __exports__